/** @format */

import { parseStrEmpty } from '@power/utils';
import type { BaseResponse } from '@/utils';
import { request } from '@/utils';

// 查询用户列表
export function listUser(query: any) {
	return request<BaseResponse<any>>(
		{
			url: '/system/user/list',
			method: 'get',
			params: query,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 查询用户详细
export function getUser(userId) {
	return request<BaseResponse<any>>(
		{
			url: `/system/user/${parseStrEmpty(userId)}`,
			method: 'get',
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 新增用户
export function addUser(data) {
	return request<BaseResponse<any>>(
		{
			url: '/system/user',
			method: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 修改用户
export function updateUser(data) {
	return request<BaseResponse<any>>(
		{
			url: '/system/user',
			method: 'put',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 删除用户
export function delUser(userId) {
	return request<BaseResponse<any>>(
		{
			url: `/system/user/${userId}`,
			method: 'delete',
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 用户密码重置
export function resetUserPwd(userId, password) {
	const data = {
		userId,
		password,
	};
	return request<BaseResponse<any>>(
		{
			url: '/system/user/resetPwd',
			method: 'put',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 用户状态修改
export function changeUserStatus(userId, status) {
	const data = {
		userId,
		status,
	};
	return request<BaseResponse<any>>(
		{
			url: '/system/user/changeStatus',
			method: 'put',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 用户锁定状态修改
export function changeUserLock(userId, lock) {
	const data = {
		userId,
		lock,
	};
	return request<BaseResponse<any>>(
		{
			url: '/system/user/changeLock',
			method: 'put',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 查询用户个人信息
export function getUserProfile() {
	return request<BaseResponse<any>>({
		url: '/system/user/profile',
		method: 'get',
	});
}

// 修改用户个人信息
export function updateUserProfile(data) {
	return request<BaseResponse<any>>(
		{
			url: '/system/user/profile',
			method: 'put',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
	const data = {
		oldPassword,
		newPassword,
	};
	return request<BaseResponse<any>>(
		{
			url: '/system/user/profile/updatePwd',
			method: 'put',
			params: data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 用户头像上传
export function uploadAvatar(data) {
	return request<BaseResponse<any>>(
		{
			url: '/system/user/profile/avatar',
			method: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 查询授权角色
export function getAuthRole(userId) {
	return request<BaseResponse<any>>(
		{
			url: `/system/user/authRole/${userId}`,
			method: 'get',
		},
		{
			isGetDataDirectly: false,
		},
	);
}

// 保存授权角色
export function updateAuthRole(data) {
	return request<BaseResponse<any>>(
		{
			url: '/system/user/authRole',
			method: 'put',
			params: data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}
